import React from 'react';

const About = () => {
    return (
        <div className=' h-screen'>
            <h1 className='text-3xl md:text-4xl text-center font-semibold my-14'><span className='border-b-2 border-b-orange-400'>
                <span className=' text-orange-400'>About </span> Us</span>
            </h1>
                    
        </div>
    );
};

export default About;